import {
  createContext,
  useContext,
  type Dispatch,
  type MutableRefObject,
  type SetStateAction,
} from 'react';

export interface MegaMenuContextProps {
  menuId: string;
  overlayDelay?: number;
  openOverlayDelay: MutableRefObject<NodeJS.Timeout | null>;
  expandedMenuItem: string;
  updateExpandedMenuItem: Dispatch<SetStateAction<string>>;
}

export const MegaMenuContext = createContext<MegaMenuContextProps>({
  menuId: '',
  openOverlayDelay: { current: null },
  expandedMenuItem: '',
  updateExpandedMenuItem: () => {},
});

export function useMegaMenuContext() {
  return useContext(MegaMenuContext);
}
